module.exports = {
  Bar: require('./lib/bar'),
  Doughnut: require('./lib/doughnut'),
  Line: require('./lib/line'),
  Pie: require('./lib/pie'),
  PolarArea: require('./lib/polar-area'),
  Radar: require('./lib/radar'),
  createClass: require('./lib/core').createClass
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chartjs/index.js
// module id = 360
// module chunks = 0